import {Component , OnInit} from '@angular/core';
import {map} from 'rxjs/operators';
import {FormBuilder , FormGroup , Validators} from '@angular/forms';
import {FuseConfigService} from '../../../../../core/services/config.service';
import {AuthService} from '../../../../../core/services/auth.service';
import {fuseAnimations} from '../../../../../core/animations';
import {Router} from '@angular/router';
import {TranslateService} from '@ngx-translate/core';
import { AppConfig } from '../../../../../app.config';
import {LogsService} from '../../../../../core/services/logs.service';
import moment from 'moment';
import {PlatformsService} from '../../../../../core/services/platforms.service';
import { NgxSpinnerService } from 'ngx-spinner';
@Component({
    selector: 'fuse-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.scss'],
    animations: fuseAnimations,
    standalone: false
})
export class FuseLoginComponent implements OnInit {
  loginForm: FormGroup;
  loginFormErrors: any;
  errMsg = '';
  monthIndex = 0;
  logoUrl = 'assets/images/logos/fuse.svg';
  months = ['junuary',
            'february',
            'march',
            'april',
            'may',
            'june',
            'july',
            'august',
            'september',
            'october',
            'november',
            'december',
  ];
  IP;
  nextAvailableLogin;
  constructor (private fuseConfig: FuseConfigService ,
               private auth: AuthService,
               private translate: TranslateService,
               private formBuilder: FormBuilder, private router: Router,
               private appConfig: AppConfig,
               private logsService: LogsService,
               private platformsService: PlatformsService,
               private spinner: NgxSpinnerService

  ) {
    this.monthIndex = new Date().getMonth();
    this.fuseConfig.setSettings({
      layout: {
        navigation: 'none' ,
        toolbar: 'none' ,
        footer: 'none'
      }
    });
    this.fuseConfig.projectSettings.subscribe((res: any) => {
      if (res && res.loginImage) {
        this.logoUrl = res.loginImage;
      }
    });

    this.loginFormErrors = {
      email: {} ,
      password: {}
    };
  }

  ngOnInit () {
    this.loginForm = this.formBuilder.group({
      email: [ '' , [ Validators.required , Validators.email ] ] ,
      password: [ '' , Validators.required ]
    });

    this.loginForm.valueChanges.subscribe(() => {
      this.onLoginFormValuesChanged();
    });
    this.getIP();
  }

  onLoginFormValuesChanged () {
    for (const field in this.loginFormErrors) {
      if (!this.loginFormErrors.hasOwnProperty(field)) {
        continue;
      }

      // Clear previous errors
      this.loginFormErrors[ field ] = {};

      // Get the control
      const control = this.loginForm.get(field);

      if (control && control.dirty && !control.valid) {
        this.loginFormErrors[ field ] = control.errors;
      }
    }
  }

  getIP() {
    this.spinner.show();
    this.auth.getApi().subscribe({next: (api: any) => {
      if (api && api.ip) {
        this.IP = api.ip;
        this.spinner.hide();
      }
    }, error: (e) => {
        this.spinner.hide();
    }});
  }

  logIn () {
    this.errMsg = '';
    this.auth.checkError(this.IP).subscribe((error: any) => {
      if (error && error.error) {
        this.errMsg = 'too_many_logins';
        this.nextAvailableLogin = Math.floor(error.error / 60000);
      } else {
        this.auth.login(this.loginForm.value).pipe(map(
          (res) => {
            if (res[ 'error' ]) {
              this.errMsg = res[ 'error' ];
              if (this.errMsg === 'Bad login/password') {
                this.auth.addLoginError(this.IP).subscribe();
              }
            } else {
              this.auth.clearError(this.IP).subscribe();
              localStorage.setItem('loginError', '0');
              localStorage.setItem('loginErrorDate', '');
              console.log('Done');
              this.auth.setSession(res);
              this.fuseConfig.setToken(res['accessToken']);
              localStorage.setItem('name', res['lastName'] + ' ' + res['firstName']);
              localStorage.setItem('id', res['id']);
              localStorage.setItem('canRecommend', res['canRecommend']);
              localStorage.setItem('allowCompetency', res['allowCompetency']);
              localStorage.setItem('role', res['role'].name);
              localStorage.setItem('eCall', res['eCall']);
              localStorage.setItem('whatsapp', res['whatsapp']);
              localStorage.setItem('organizationId', res['organizationId']);
              localStorage.setItem('logo', res['logo']);
              localStorage.setItem('lang', res['lang']);
              localStorage.setItem('privacy', res['privacy']);
              localStorage.setItem('userEmail', res['email']);
              this.translate.use(localStorage.getItem('lang'));
              this.fuseConfig.setUserName(res['lastName'] + ' ' + res['firstName']);
              this.fuseConfig.setUserId(res['id']);
              this.fuseConfig.userId_Sig.set(res['id']);
              this.fuseConfig.setCanRecommend(res['canRecommend']);
              this.fuseConfig.setAllowCompetency(res['allowCompetency']);
              this.fuseConfig.setECall(res['eCall']);
              this.fuseConfig.setWhatsApp(res['whatsapp']);
              this.fuseConfig.setRole(res['role'].name);
              this.fuseConfig.role_Sig.set(res['role'].name);
              this.fuseConfig.setUserEmail(res['email']);
              if (res['role'].name === 'organisationAdmin') {
                this.fuseConfig.setOrganizationId(res['organizationId']);
                this.fuseConfig.organizationId_Sig.set(res['organizationId']);
                this.platformsService.getByOrganizationId(res['organizationId'], true).subscribe(platform => {
                  this.fuseConfig.setPlatforms(platform);
                });
              } else {
                this.fuseConfig.setOrganizationId(null);
                this.fuseConfig.organizationId_Sig.set(null);
                this.fuseConfig.setPlatforms(null);
              }
              this.fuseConfig.setLogo(res['logo']);
              this.fuseConfig.setPrivacy(res['privacy']);
              this.appConfig.setAuthToken(res['accessToken']);

              if (res.hasOwnProperty('organizationName')) {
                localStorage.setItem('organizationName', res['organizationName']);
                this.fuseConfig.setOrganizationName(res['organizationName']);
              } else {
                localStorage.setItem('organizationName', '');
                this.fuseConfig.setOrganizationName('');
              }

              if (res.hasOwnProperty('organizationType')) {
                localStorage.setItem('organizationType', res['organizationType']);
                this.fuseConfig.setOrganizationType(res['organizationType']);
              } else {
                localStorage.setItem('organizationType', '');
                this.fuseConfig.setOrganizationType('');
              }

              if (res.hasOwnProperty('country')) {
                localStorage.setItem('country', JSON.stringify(res['country']));
                this.fuseConfig.setCountry(res['country']);
              } else {
                localStorage.setItem('country', '');
                this.fuseConfig.setCountry('');
              }

              if (res.hasOwnProperty('city')) {
                localStorage.setItem('city', JSON.stringify(res['city']));
                this.fuseConfig.setCity(res['city']);
              } else {
                localStorage.setItem('city', '');
                this.fuseConfig.setCity('');
              }

              setTimeout(() => {
                this.router.navigate(['/']);
                this.logsService.addLogs('login').subscribe(resultLog => {
                });
              }, 1000);
              if (res['role'] === 'superAdmin') {
                this.fuseConfig.setSuperAdmin('true');
                localStorage.setItem('email', res['email']);
                localStorage.setItem('password', res['password']);
              }
            }
          })).subscribe();
      }
    });
  }
}
